import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { ICON_VIEWBOX, DEFAULT_VALUE_VARIATION } from './constants.js';
import { StyledButton, StyledLoadingIcon, I } from './styles.js';

const Button = forwardRef((_a, ref) => {
    var { children, variation = DEFAULT_VALUE_VARIATION, size = 'small', disabled = false, icon: Icon, iconRight: IconRight, iconLeft: IconLeft, onClick, fixed = false, isLoading = false, href, target } = _a, props = __rest(_a, ["children", "variation", "size", "disabled", "icon", "iconRight", "iconLeft", "onClick", "fixed", "isLoading", "href", "target"]);
    return (React.createElement(StyledButton, Object.assign({ variation: variation, size: size, disabled: disabled || isLoading, onClick: disabled ? undefined : onClick, fixed: fixed, hasChildren: Boolean(children), ref: ref, as: href ? 'a' : 'button', href: href, target: target, isLoading: isLoading, "aria-busy": isLoading }, props),
        isLoading ? (React.createElement(StyledLoadingIcon, { variation: variation, size: size })) : null,
        IconLeft && (React.createElement(I, { iconLeft: IconLeft, size: size },
            React.createElement(IconLeft, { viewBox: ICON_VIEWBOX }))),
        Icon && !children && (React.createElement(I, { size: size, centralized: true },
            React.createElement(Icon, { viewBox: ICON_VIEWBOX }))),
        children,
        IconRight && (React.createElement(I, { size: size },
            React.createElement(IconRight, { viewBox: ICON_VIEWBOX })))));
});
Button.displayName = 'Button';

export { Button as default };
